<template>
  <v-main class="fill-height">
    <div class="flex items-center p-5 lg:p-20">
      <div
        class="items-center flex-1 min-w-full min-h-full p-10 text-center bg-white shadow-xl rounded-3xl lg:p-20 md:flex md:text-left"
      >
        <div class="w-full md:w-1/2">
          <div class="mb-10 md:mb-20">
            <h1 class="mb-10 text-3xl font-black uppercase text-indigo lg:text-5xl">
              Acesso negado!
            </h1>
            <p>Você não tem permissão para estar aqui.</p>
          </div>

          <div class="mb-20 md:mb-0">
            <v-button type="danger" @click="goToFeed">
              <fa icon="long-arrow-alt-left" class="mr-2" /> Voltar
            </v-button>
          </div>
        </div>

        <div class="w-full text-center md:w-1/2">
          <img
            :src="require('@/assets/403.svg')"
            class="w-full max-w-lg mx-auto lg:max-w-full"
            alt="403"
          />
        </div>
      </div>
    </div>

    <div
      class="absolute w-64 transform -rotate-45 bg-blue-200 rounded-full pointer-events-none md:w-96 h-96 md:h-full bg-opacity-30 -top-64 md:-top-96 right-20 md:right-32"
    />
    <div
      class="absolute h-full transform -rotate-45 bg-yellow-200 rounded-full pointer-events-none w-96 bg-opacity-20 -bottom-96 right-64"
    />
  </v-main>
</template>

<script>
export default {
  name: 'ForbiddenPage',

  methods: {
    goToFeed() {
      this.$router
        .push({ name: 'dashboard' })
        .then(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    },
  },
};
</script>
